export const generatePdfFilename = (salesOrderNumber: string): string => {
  return `sales-order-${salesOrderNumber}`
    .replace(/[^a-z0-9]/gi, '_')
    .toLowerCase();
};
